enum Devices {
  mobile = 'screen and (max-width: 480px)',
  tablet = 'screen and (max-width: 768px)',
  laptop = 'screen and (max-width: 1224px)',
  desktop = 'screen and (max-width: 1824px)',
}

export default Devices;
